import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormControlService } from '../../services/form-control.service';
import { NumpadService } from '../../services/numpad.service';
import { Router } from '@angular/router';
import { KeyboardConfigService } from '../../services/keyboard-config.service';
import { Observable, BehaviorSubject, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'ticketing-numpad',
  templateUrl: './numpad.component.html',
  styleUrls: ['./numpad.component.scss']
})
export class NumpadComponent implements OnInit, OnChanges {
  @Input() forceShow: boolean = false;
  shouldHideNumpad$: Observable<boolean>;
  private forceShowSubject = new BehaviorSubject<boolean>(false);

  constructor(
    public formControlService: FormControlService, 
    private router: Router,
    private keyboardConfigService: KeyboardConfigService
  ) {
    this.shouldHideNumpad$ = combineLatest([
      this.keyboardConfigService.keyboardConfig$,
      this.forceShowSubject.asObservable()
    ]).pipe(
      map(([config, forceShow]) => forceShow ? false : config.hideNumeric)
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['forceShow']) {
      this.forceShowSubject.next(this.forceShow);
    }
  }

  ngOnInit() {
    this.forceShowSubject.next(this.forceShow);
  }

  send(key: string) {
    if (this.formControlExists()) {
      this.formControlService.inputChar(key);
    }
  }

  deleteOne() {
    if (this.formControlExists()) {
      this.formControlService.deleteChar();
    }
  }

  setToBlank() {
    if (this.formControlExists()) {
      this.formControlService.setToBlank();
    }
  }

  formControlExists() {
    return this.formControlService.currentFormGroupValue;
  }

  acceptChanges() {
    return this.formControlService.acceptChanges();
  }
}
